import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section style={{
      padding: '120px 40px',
      backgroundColor: '#e8f4f5',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Golden Geometric Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.15,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' stroke='%23C9A227' stroke-width='1'%3E%3Cpath d='M0 0l40 40M40 0l40 40M0 40l40 40M40 40l40 40M0 0l40 40-40 40M40 0l40 40-40 40' stroke-opacity='0.4'/%3E%3Ccircle cx='40' cy='40' r='2' fill='%23C9A227' fill-opacity='0.3'/%3E%3Ccircle cx='0' cy='0' r='2' fill='%23C9A227' fill-opacity='0.3'/%3E%3Ccircle cx='80' cy='0' r='2' fill='%23C9A227' fill-opacity='0.3'/%3E%3Ccircle cx='0' cy='80' r='2' fill='%23C9A227' fill-opacity='0.3'/%3E%3Ccircle cx='80' cy='80' r='2' fill='%23C9A227' fill-opacity='0.3'/%3E%3C/g%3E%3C/svg%3E")`,
        backgroundSize: '80px 80px',
        zIndex: 1
      }} />

      {/* Decorative Golden Circles */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '200px',
        height: '200px',
        background: 'radial-gradient(circle, rgba(201, 162, 39, 0.2) 0%, transparent 70%)',
        borderRadius: '50%',
        zIndex: 1
      }} />
      <div style={{
        position: 'absolute',
        bottom: '10%',
        right: '10%',
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(201, 162, 39, 0.15) 0%, transparent 70%)',
        borderRadius: '50%',
        zIndex: 1
      }} />

      <div className="container" style={{
        maxWidth: '900px',
        margin: '0 auto',
        textAlign: 'center',
        position: 'relative',
        zIndex: 2
      }}>
        <h2 style={{
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 900,
          fontSize: 'clamp(2.5rem, 5vw, 4rem)',
          lineHeight: 1.1,
          background: 'linear-gradient(135deg, #0a4447 0%, #C9A227 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          textTransform: 'uppercase',
          marginBottom: '24px'
        }}>
          Ready for a Resolution?
        </h2>
        
        <p style={{
          fontFamily: 'Lato, sans-serif',
          fontSize: 'clamp(1.125rem, 2vw, 1.5rem)',
          lineHeight: 1.6,
          color: '#0a4447',
          marginBottom: '48px',
          maxWidth: '700px',
          margin: '0 auto 48px'
        }}>
          Stop wrestling with technology and start solving your core business challenges. 
          Book a complimentary assessment call to discover a clear path forward.
        </p>

        <Link 
          to="/contact"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '12px',
            background: 'linear-gradient(135deg, #0D7377 0%, #0a4447 100%)',
            color: '#ffffff',
            padding: '18px 48px',
            borderRadius: '10rem',
            textDecoration: 'none',
            fontFamily: 'Lato, sans-serif',
            fontWeight: 700,
            fontSize: '1.125rem',
            textTransform: 'uppercase',
            letterSpacing: '-0.02em',
            transition: 'all 0.3s ease',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(13, 115, 119, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 8px 30px rgba(13, 115, 119, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(13, 115, 119, 0.3)';
          }}
        >
          Book Your Free Assessment
          <ArrowRight size={20} />
        </Link>

        <p style={{
          fontFamily: 'Lato, sans-serif',
          fontSize: '0.875rem',
          color: '#4a5568',
          marginTop: '24px'
        }}>
          No obligation. No sales pressure. Just honest advice.
        </p>
      </div>
    </section>
  );
};

export default CTASection;
